import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import api from "@/lib/api";
import { Users, Shield, Mail, Crown } from "lucide-react";

const ROLE_LABEL = { org_owner: "Organization Owner", org_admin: "Organization Administrator", head_coach: "Head Coach", assistant_coach: "Assistant Coach", team_manager: "Team Manager", scorekeeper: "Scorekeeper", parent: "Parent", player: "Player" };

export default function OrgStaff() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/live/organizations/${slug}/staff`).then(({ data }) => setData(data)).catch(() => setError("Organization not found"));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#F1F3F6]"><Header />
      <div className="bg-[#0A192F] text-white">
        <div className="max-w-4xl mx-auto px-6 py-10">
          <div className="label-overline text-[#E63946] flex items-center gap-2"><Users className="w-4 h-4" /> Organization Directory</div>
          <h1 className="font-display text-4xl uppercase tracking-tighter mt-1" data-testid="org-staff-title">{data?.organization?.name || "Staff"}</h1>
          {data?.organization?.founding_member && (
            <span data-testid="org-founding-badge" className="inline-flex items-center gap-1 mt-2 text-[11px] font-bold uppercase tracking-wider bg-[#E63946]/20 text-[#E63946] px-2.5 py-1 rounded-full">
              <Crown className="w-3.5 h-3.5" /> Founding Member
            </span>
          )}
          <p className="text-sm text-white/60 mt-2">Everyone responsible for this organization and its teams.</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 py-8" data-testid="org-staff-page">
        {error ? <div className="text-sm text-[#E63946]">{error}</div>
          : !data ? <div className="text-slate-400">Loading…</div>
          : data.members.length === 0 ? <div className="bg-white border border-dashed border-slate-200 rounded-sm py-16 text-center text-slate-400">No staff listed yet.</div>
          : <div className="grid sm:grid-cols-2 gap-3">
              {data.members.map((m, i) => (
                <div key={i} className="bg-white border border-slate-200 rounded-sm p-4 flex items-center gap-3" data-testid={`staff-member-${i}`}>
                  <div className="w-11 h-11 rounded-full bg-slate-100 grid place-items-center shrink-0 overflow-hidden">
                    {m.profile_photo_url ? <img src={m.profile_photo_url} alt="" className="w-full h-full object-cover" /> : <Shield className="w-5 h-5 text-slate-300" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold truncate">{m.name}</div>
                    <div className="text-[11px] text-[#E63946] font-semibold uppercase tracking-wider">{ROLE_LABEL[m.role] || m.role}</div>
                    {m.team && <Link to={`/live/teams/${m.team.slug}`} className="text-[11px] text-slate-400 hover:text-[#0A192F]">{m.team.name}</Link>}
                    {m.email && <div className="text-[11px] text-slate-400 flex items-center gap-1 mt-0.5"><Mail className="w-3 h-3" />{m.email}</div>}
                  </div>
                </div>
              ))}
            </div>}
      </div>
    </div>
  );
}
